import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { ModalService } from '../../services/modal/modal.service';

export const MODAL_CONFIRM = 'confirm';

@Component({
  selector: 'lepi-modal-adapter',
  template: '',
})
export class ModalAdapter<T = any> implements OnInit {
  readonly modalService = inject(ModalService);
  private readonly _props = inject(DIALOG_DATA);
  private readonly dialogRef = inject(DialogRef);

  private props$ = new Subject<T>();
  props = toSignal(this.props$);

  ngOnInit(): void {
    this.props$.next(this._props);
  }

  close(result?: unknown) {
    const element = this.modalService.getElement();
    if (element) {
      const closeAnimation = element.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 200,
        easing: 'ease-in-out',
      });
      closeAnimation!.onfinish = () => {
        this.dialogRef.close(result);
      };
    }
  }
}
